import { motion } from 'framer-motion';
import { useState } from 'react';
import { fadeIn } from '../../../utils/motion';
import axios from 'axios';
import 'react-toastify/dist/ReactToastify.css';

function DangerZone() {

  // States to track form data
  const [reason, setReason] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  // State to track loading, errors, and success
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null); // New state for success message

  const handleHolidayRequest = async () => {
    if (!reason || !startDate || !endDate) {
      setError("Please fill out all fields.");
      return;
    }

    setLoading(true); 
    setError(null); 
    setSuccessMessage(null); // Reset success message

    const holidayData = {
      reason,
      startDate,
      endDate,
    };

    try {
      console.log(JSON.parse(localStorage.getItem('authMandoub'))?.token);
      
      const response = await axios.post(process.env.REACT_APP_API_URL+'mandoub/holiday', holidayData, {
        headers: {
            Authorization : `Bearer ${JSON.parse(localStorage.getItem('authMandoub'))?.token}`
        },
        withCredentials: true,
    });

      // Set success message
      setSuccessMessage('تم إرسال طلبكم إلى الإدارة بنجاح!'  );
      

    } catch (err) {
      // Handle error
      console.error(err);
      setError('حدث خطأ أثناء تحديث معلوماتك.');
    } finally {
      setLoading(false); // Set loading state back to false
    }
  };

  return (
    <motion.div variants={fadeIn("right", "tween", 1 * 0.2, 1)} className="section-card edit-section">
      <div className="df-c danger">
        <div className="df-c w-full !alighn-start">
          <div className="title mx-auto">طلب إجازة</div>
          <div className="df-c pr w-full">
            <label htmlFor="reason" className="label-trans !right-10">السبب</label>
            <input
              type="text"
              id="reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="mx-auto"
              style={{ width: "90%", height: "7rem" }}
            />
          </div>
          <div className="df jc-sb w-11/12">
            <div className="df-c pr">
              <label className="label-trans">تاريخ البداية</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="mx-auto"
              />
            </div>
            <div className="df-c pr">
              <label className="label-trans">تاريخ النهاية</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="mx-auto"
              />
            </div>
          </div>
        </div>
        <div className="df justify-center text-center header-btns w-full">
        </div>
        {loading && <div>Loading...</div>} 
        {error && <div className="error">{error}</div>}
        {successMessage && <div className="success">{successMessage}</div>} {/* Display success message */}
        <div className="df header-btns justify-center w-full">
          <motion.button
            className="btn justify-center w-1/2"
            disabled={loading}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={() => { handleHolidayRequest(); }}
          >
            طلب إجازة
          </motion.button>
        </div>
        <div className="df header-btns justify-center w-full">
        </div>
      </div>
    </motion.div>
  );
}

export default DangerZone;